import { createSelector } from 'reselect';

const selectLogisticsConfigurations = (state: any) => state.logisticsConfigurations;

export const selectLogisticsConfigurationsCurrentItem = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.current);

export const selectLogisticsConfigurationsListItems = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectLogisticsConfigurationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLogisticsConfigurationsCreatedItem = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.create);

export const selectLogisticsConfigurationsUpdatedItem = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.update);

export const selectLogisticsConfigurationsQueryItem = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.query);

export const selectLogisticsConfigurationsReadItem = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.read);

export const selectLogisticsConfigurationsDeletedItem = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.delete);

export const selectLogisticsConfigurationsSearchedItems = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.search);

export const selectLogisticsConfigurationsItemsCount = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.count);

export const selectLogisticsConfigurationsItemsFilter = createSelector([selectLogisticsConfigurations], (logisticsConfigurations) => logisticsConfigurations.filter);